define([
	"dojo/_base/declare",
	"csi",
	"csi/heading/RefImageContainer",
	"csi/image/_base"
], function(declare,csi,RefImageContainer,csiImage) {

	return declare(RefImageContainer, {
		getReferencedNodes: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return images ordered by numeric key
			var value = this._getValue(ctx, h);
			var keys = csiImage.getNumberedKeys(value);

			return csi.transform(keys, function(key) {
				return ctx.cache.getNode(value[key], true);
			});
		}
	});
});